import { NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

import {
  FeatureDiscoveryStepperComponent,
  FeatureDiscoveryStepperComponentI,
} from '@core/feature-discovery-ui';
import { injectTranslate, TranslatePipe } from '@core/i18n-legacy';
import { SkillsIdeateCacheService } from '@core/tellent-skills-logic';
import {
  ButtonComponent,
  CheckboxComponent,
  DialogBodyComponent,
  DialogComponentI,
  DialogFooterComponent,
  DialogRef,
  HeadingComponent,
  IconComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'tlc-skills-ideate-intro-dialog',
  templateUrl: './skills-ideate-intro-dialog.component.html',
  styleUrl: './skills-ideate-intro-dialog.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DialogBodyComponent,
    DialogFooterComponent,
    ButtonComponent,
    CheckboxComponent,
    HeadingComponent,
    IconComponent,
    ReactiveFormsModule,
    TranslatePipe,
    FeatureDiscoveryStepperComponent,
    NgOptimizedImage,
  ],
})
export class SkillsIdeateIntroDialogComponent implements DialogComponentI<
  void,
  Record<string, never>
> {
  private readonly t = injectTranslate();
  private readonly cacheService = inject(SkillsIdeateCacheService);
  private readonly dialogRef = inject(DialogRef);

  protected readonly dontShowAgainControl = new FormControl<boolean>(false, { nonNullable: true });

  protected readonly steps: FeatureDiscoveryStepperComponentI[] = [
    {
      content: this.t('tlc.positions.skills_ideate_flow.intro.steps.select.content'),
    },
    {
      content: this.t('tlc.positions.skills_ideate_flow.intro.steps.generate.content'),
    },
    {
      content: this.t('tlc.positions.skills_ideate_flow.intro.steps.review.content'),
    },
  ];

  public setDialogData(_data: void, _triggerUpdate: boolean): void {
    //
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public continue(): void {
    if (this.dontShowAgainControl.value) {
      this.cacheService.setDontShowIntroFlag().then(() => {
        this.dialogRef.close({});
      });
      return;
    }
    this.dialogRef.close({});
  }
}
